import React from 'react'
import { Container } from 'typescript-ioc/es5'
import { AsyncButton } from '../../../components/async-button/async-button.component'
import { AppService } from '../../../services'
import JourneyTableWell from '../journey-table-well/journey-table-well'
import './journey-list.scss'
import { PageHeader } from '../../../components/page-header/page-header'
import { CurrentUserCan } from '../../../stores/app-ability'
import { AbilityAction } from '../../../enums/ability-action.enum'
import { SubjectEntity } from '../../../enums/ability-entity.enum'
import { AppState } from '../../../stores/app'

export class JourneyList extends React.Component {
    protected appState: AppState
    protected appService: AppService

    public constructor(props) {
        super(props)

        this.appState = Container.get(AppState)
        this.appService = Container.get(AppService)
    }

    public render(): React.ReactNode {
        const { abilityStore } = this.appState
        return (
            <div className="journey-list">
                <PageHeader
                    title="Journeys"
                    action={
                        <CurrentUserCan
                            do={AbilityAction.CREATE}
                            on={abilityStore.getDomainOwnedIdentityFor(SubjectEntity.CAMPAIGN)}
                        >
                            <AsyncButton
                                className="new-notification-button"
                                type="primary"
                                altHref={this.buildCreateJourneyUrl()}
                                onClick={this.jumpToCreateJourney}
                            >
                                <span>Create Journey</span>
                            </AsyncButton>
                        </CurrentUserCan>
                    }
                />

                <JourneyTableWell {...this.props} />
            </div>
        )
    }

    protected buildCreateJourneyUrl = (): string => {
        return this.appService.routeWithinDomain('/journeys/new', true)
    }

    protected jumpToCreateJourney = (): void => {
        this.appService.route(this.buildCreateJourneyUrl())
    }
}
